<template>
	<div id="login-again" class="page centered-container">
		<img class="svg partner-logo" v-bind:src="imgLogo" :alt="imgAlt" />

		<p role="heading" aria-level="1" id="login-again-heading" class="standard-heading" v-t="'loginAgain'" />

		<p id="login-again-text" class="standard-text">{{displayMessage}}</p>

		<template v-if="arToken">
			<a class="standard-button" href="#" v-on:click.prevent="back"><span v-t="'goBack'" /></a>
		</template>
		<template v-else>
			<a class="standard-button" href="#" v-on:click.prevent="home"><span v-t="'goHome'" /></a>
		</template>
	</div>
</template>

<script>
import i18nJ from '@/plugins/i18nJ';

export default {
	name: 'LoginAgainPage',
	props: [],
	data: function() {
		return ar.state;
	},
	methods: {
		home: function () {
			arRouter.push('/');
		},
		back: function () {
			ar.goToCorrectRemotePage();
		}
	},
	computed: {
		imgLogo: function() {
			return ar.partnerLogoUrl(this.partner);
		},
		imgAlt: function () {
			return ar.partnerLogoAltText(this.partner);
		},
		displayMessage: function() {
			const urlParams = new URLSearchParams(window.location.search);
			let   msg = urlParams.get('msg');
			let theMessage;
			if ( msg ) {
				theMessage = msg;
			} else {
				theMessage = i18nJ.t('needToRelogin');
			}
			return theMessage;
		}
	}, 
	mounted: function() {
		window.focusPageHeading();
		window.setPageTitle('loginAgain');
	}
};
</script>

<style scoped>
	#login-again-text {
		margin-bottom: 3rem;
	}
</style>
